import React from "react";
import { PERMISSION_MODULES } from "@/lib/permissions";
import { Lock } from "lucide-react";

/**
 * Per-module View / Manage checkbox matrix. Controlled component.
 * value: { moduleKey: { view, manage } }. Manage implies View.
 */
export default function PermissionsMatrix({ value, onChange, disabled = false }) {
  const set = (key, field, checked) => {
    const cur = value[key] || { view: false, manage: false };
    let next;
    if (field === "manage") {
      next = { view: checked ? true : cur.view, manage: checked };
    } else {
      next = { view: checked, manage: checked ? cur.manage : false };
    }
    onChange({ ...value, [key]: next });
  };

  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden" data-testid="permissions-matrix">
      <div className="grid grid-cols-[1fr_auto_auto] gap-x-6 bg-slate-50 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
        <span>Module</span>
        <span className="w-12 text-center">View</span>
        <span className="w-14 text-center">Manage</span>
      </div>
      {PERMISSION_MODULES.map((m) => {
        const v = value[m.key] || { view: false, manage: false };
        return (
          <div key={m.key} className="grid grid-cols-[1fr_auto_auto] gap-x-6 items-center px-4 py-2.5 border-t border-slate-100">
            <div>
              <p className="text-sm font-semibold text-slate-800 flex items-center gap-1.5">
                {m.label}
                {m.sensitive && <Lock className="w-3 h-3 text-amber-500" title="Sensitive — pricing / financials" />}
              </p>
              <p className="text-xs text-slate-400">{m.desc}</p>
            </div>
            <label className="w-12 flex justify-center">
              <input type="checkbox" disabled={disabled} checked={v.view}
                onChange={(e) => set(m.key, "view", e.target.checked)}
                data-testid={`perm-${m.key}-view`}
                className="w-5 h-5 rounded accent-blue-600 cursor-pointer disabled:opacity-50" />
            </label>
            <label className="w-14 flex justify-center">
              <input type="checkbox" disabled={disabled} checked={v.manage}
                onChange={(e) => set(m.key, "manage", e.target.checked)}
                data-testid={`perm-${m.key}-manage`}
                className="w-5 h-5 rounded accent-emerald-600 cursor-pointer disabled:opacity-50" />
            </label>
          </div>
        );
      })}
    </div>
  );
}
